<table
  (matSortChange)="onSort($event)"
  [dataSource]="dataSource"
  mat-table
  matSort
  appResizableColumn>
  <ng-container
    *ngFor="let column of tableColumns$ | async"
    matColumnDef="{{ column.name }}">
    <th
      (mousedown)="onColumnResize($event, column.name)"
      (touchstart)="onColumnResize($event, column.name)"
      *matHeaderCellDef
      class="admia-table-resizable"
      mat-header-cell>
      {{ column.text | translate }}
    </th>

    <td *matCellDef="let order" mat-cell>
      {{ order[column.name] }}
    </td>
  </ng-container>

  <tr
    #absenceHeader
    *matHeaderRowDef="displayedColumns; sticky: true"
    mat-header-row>
  </tr>

  <tr
    #absenceRow
    (click)="onClick(row)"
    (keydown.enter)="onClick(row)"
    (mouseover)="onHover(i)"
    *matRowDef="let row; columns: displayedColumns; let i = index"
    [ngClass]="{ selected: i === (selectedIndex$ | async) }"
    mat-row>
  </tr>
</table>
